import { render, staticRenderFns } from "./SubscriptionProducts.vue?vue&type=template&id=3089a09c"
import script from "./SubscriptionProducts.vue?vue&type=script&lang=js"
export * from "./SubscriptionProducts.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionProducts.vue?vue&type=style&index=0&id=3089a09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports